export const BASE_URL = '/api/scrapper'
